import Swal from "sweetalert2";
export default {
  data() {
    return {
      email: "",
      newPassword: "",
      confirmPassword: "",
      successMessage: "",
      errorMessage: "",
      isTokenValid: null, // 初始化為 null
    };
  },
  async created() {
    // 從 URL 取得 Token 和 Email
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");
    const email = urlParams.get("email");

    console.log("Token from URL:", token);
    console.log("Email from URL:", email);

    if (!token || !email) {
      this.errorMessage = "密碼重置連結無效或已過期。";
      this.isTokenValid = false;
      return;
    }

    try {
      // 發送 Token 驗證請求
      const response = await fetch(
        `https://localhost:7107/api/Forgot/validate-token?token=${encodeURIComponent(
          token
        )}&email=${encodeURIComponent(email)}`
      );
      console.log("API response:", response); // 調試用

      if (response.ok) {
        // Token 驗證成功
        const data = await response.json();
        console.log("Token valid:", data); // 調試用
        this.isTokenValid = true;
        this.email = email;
      } else {
        // Token 驗證失敗
        const data = await response.json();
        this.errorMessage = data.Message || "密碼重置連結無效或已過期。";
        this.isTokenValid = false;
      }
    } catch (error) {
      console.error("Error validating token:", error);
      this.errorMessage = "無法驗證密碼重置連結，請稍後再試。";
      this.isTokenValid = false;
    }
  },
  methods: {
    async handleSubmit() {
      this.errorMessage = ""; // 清空之前的錯誤訊息
      this.successMessage = ""; // 清空之前的成功訊息

      // 驗證輸入欄位
      if (!this.newPassword || !this.confirmPassword) {
        this.errorMessage = "密碼欄位不得為空。";
        return;
      }
      if (this.newPassword !== this.confirmPassword) {
        this.errorMessage = "新密碼與確認密碼不一致。";
        return;
      }

      try {
        // 從 URL 中提取 Token
        const token = new URLSearchParams(window.location.search).get("token");
        if (!token) {
          this.errorMessage = "無法取得密碼重置 Token，請重試。";
          return;
        }

        // 發送密碼重置請求
        const response = await fetch(
          "https://localhost:7107/api/Forgot/reset-password",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              email: this.email, // 確保 Email 已正確綁定
              token: token, // 傳遞 Token
              newPassword: this.newPassword, // 傳遞新密碼
            }),
          }
        );

        if (response.ok) {
          const data = await response.json();
          this.successMessage = data.Message || "密碼已成功重置！";

          // 添加跳轉到登入頁的邏輯
          setTimeout(() => {
            Swal.fire({
              icon: "success", // 成功圖示
              title: "密碼重置成功", // 標題
              text: "將跳轉到登入頁面！", // 提示內容
              confirmButtonText: "確定",
            }).then(() => {
              window.location.href = "/login"; // ✅ 點擊確定後導向登入頁
            });
          }, 1000); // 2秒後跳轉，可根據需求調整時間
        } else {
          const errorData = await response.json();
          this.errorMessage = errorData.Message || "密碼重置失敗，請稍後再試。";
        }
      } catch (error) {
        console.error("Error occurred while resetting password:", error);
        this.errorMessage = "無法連接伺服器，請稍後再試。";
      }
    },
  },
};
